module.exports = __webpack_public_path__ + "assets/img/typeIcon-2-blue.4db37e1e.svg";